import React, { useEffect, useState } from 'react';
import WalletIcon from 'src/assets/icons/WalletIcon';
import {  useHistory } from 'react-router-dom';
import useApi from 'src/hooks/useApi';
import services from 'src/api/service';
import { formatCurrency } from '../../../../../views/pages/dsp-payment/wallet-page/index';
import { currencyFormatter } from 'src/views/pages/Dsp/Common/utils';
import useGetWalletDetails from 'src/views/pages/dsp-payment/hooks/useGetWalletDetails'
import { useAmzDspContext } from 'src/contexts/AmzDspContext';

function index() {
    const history = useHistory();
    const { amzDspState, amzDspDispatch } = useAmzDspContext();
    const doGetWalletBalance = useApi(services.postService);
    const { dspAccount } = useGetWalletDetails()

  const handleOpen = () => {
    history.push('/billing-payments?type=recharge&view=brand')
  };


  useEffect(() => {

    if(dspAccount?.dspId){
      doGetWalletBalance.request({
        url: '/dsp/wallet-list',
        nodeAPI: 1,
        payload: {
          dspId: dspAccount?.dspId
          // ...(dspAccount?.dspId && {
          //   dspId: Number(dspAccount?.dspId)
          // })
        }
      });
    }
  }, [dspAccount]);
  useEffect(() => {
    const { loading, data } = doGetWalletBalance;
    if (!loading && data && data?.success === true) {
      if(data?.data?.wallet_balance || data?.data?.wallet_credits) {
        const totalCredits = Object.values(data?.data?.wallet_credits || {}).reduce((sum, credit) => sum + (Number(credit) || 0), 0);
        const walletBalance = (Number(data?.data?.wallet_balance) || 0) + totalCredits;
        amzDspDispatch({ type: 'UPDATE_WALLET_BALANCE', payload: walletBalance });
      }
      const filteredWalletDetails = {
        wallet_id: data?.data?._id,
        minimum_amount: data?.data?.minimum_amount,
        currency: data?.data?.currency,
        hector_fees_percentage: data?.data?.hector_fees_percentage,
        agency_fees_percentage: data?.data?.agency_fees_percentage,
        paymentMethod: data?.data?.paymentMethod,
        ...(data?.data?.agencyWallet && { agency_wallet: data?.data?.agencyWallet }),
        displaySettings: data?.data?.agencyWallet?.displaySettings ?? { commissionShow: false, commissionMask: false, maskValue: 0 },
        dspClientName: data?.data?.dspClientName,
        pauseCampaigns: data?.data?.pauseCampaigns
      };
      amzDspDispatch({ type: 'UPDATE_WALLET_DETAILS_DATA', payload: filteredWalletDetails });
    } else if (!loading && data && data?.success === false) {
      amzDspDispatch({ type: 'UPDATE_WALLET_BALANCE', payload: 0 });
    }
  }, [doGetWalletBalance.loading]);

  return (
    <>
      <section className="global-filter " onClick={handleOpen} style={{border:'1px solid #5932EA', font:'Open Sans'}}>
        <WalletIcon />
        <p className=" f-w-600 f-14"> Balance {currencyFormatter(amzDspState?.walletBalance)} 
          </p>
      </section>
      
    </>
  );
}

export default index;
